import { Button } from "@chakra-ui/react";
import { Icon } from "assets/Icon";
import { cn } from "utils/helpers";
import { ButtonViewGroupProps } from "./types";

const commonButtonStyle =
	"h-[40px] shadow-input bg-white text-black font-semibold px-6 py-4 border border-[#D0D5DD] flex gap-2 items-center rounded-l-[4px] self-center active:bg-gray-200 hover:bg-gray-50 focus:ring-2 focus:ring-gray-200";

export const ButtonViewGroup: React.FC<ButtonViewGroupProps> = ({
	setView,
	view,
	className,
}) => {
	return (
		<div className={cn("sm:hidden lg:flex", className)}>
			<Button
				className={cn(commonButtonStyle, view === "grid" && "bg-gray-100")}
				onClick={() => setView("grid")}
			>
				<Icon
					icon="dashboard"
					style={{ color: "#475467" }}
				/>
			</Button>
			<Button
				className={cn(commonButtonStyle, view === "list" && "bg-gray-100")}
				onClick={() => setView("list")}
			>
				<Icon
					icon="list-view"
					style={{ color: "#475467" }}
				/>
			</Button>
		</div>
	);
};

export default ButtonViewGroup;
